import { DoesFilterPassParams } from "ag-grid-enterprise";
import { DateUtils } from "utils/dateutils";

const dateFormat = "MM/DD/YYYY";

type TModelDateType = {
  values: string[];
  filterType: string;
  type?: string;
  dateFrom?: string;
  dateTo?: string;
};

export const doesFilterPass: ({
  model,
  node,
  handlerParams
}: DoesFilterPassParams<any, any, TModelDateType>) => boolean = ({
  model,
  node,
  handlerParams
}: DoesFilterPassParams<any, any, TModelDateType>) => {
  const value = handlerParams.getValue(node);
  const selectedFilter = model?.values?.length ? model.values[0] : "";

  if (
    value ||
    selectedFilter === "CustomDateRange" ||
    selectedFilter === "Actual Date NA" ||
    selectedFilter === "no date present"
  ) {
    const cellDateValue = value ? DateUtils.dateTimeObj(value).valueOf() : 0;
    const todayDateValue = DateUtils.dateTimeObj(
      DateUtils.format(DateUtils.dateTimeObj())
    ).valueOf();

    switch (selectedFilter) {
      case "Past today": {
        const selectedDate = DateUtils.dateTimeObj(todayDateValue).valueOf();
        return selectedDate > cellDateValue && value;
      }
      case "Today": {
        const selectedDate = DateUtils.dateTimeObj().format(dateFormat);
        const todayDateString = DateUtils.dateTimeObj(value).format(dateFormat);
        return todayDateString === selectedDate && value;
      }
      case "Next 3 days": {
        const nextDate = DateUtils.dateTimeObj(todayDateValue)
          .add(4, "days")
          .valueOf();
        const today = DateUtils.dateTimeObj(todayDateValue).valueOf();
        return cellDateValue <= nextDate && cellDateValue > today && value;
      }
      case "Next 2 weeks": {
        const nextDate = DateUtils.dateTimeObj(todayDateValue)
          .add(15, "days")
          .valueOf();
        const today = DateUtils.dateTimeObj(todayDateValue).valueOf();
        return cellDateValue <= nextDate && cellDateValue > today && value;
      }
      case "CustomDateRange": {
        const fromValue = DateUtils.dateTimeObj(model?.dateFrom).valueOf();
        const toValue = DateUtils.dateTimeObj(model?.dateTo).valueOf();
        return cellDateValue >= fromValue && cellDateValue <= toValue;
      }
      case "Overdue": {
        return cellDateValue < todayDateValue;
      }
      case "Due in 5 days": {
        const { from, to } = {
          from: DateUtils.dateTimeObj(
            DateUtils.dateTimeObj().format(dateFormat)
          ).valueOf(),
          to: DateUtils.dateTimeObj(DateUtils.dateTimeObj().format(dateFormat))
            .add(6, "d")
            .valueOf()
        };
        return cellDateValue >= from && cellDateValue <= to;
      }
      case "Actual Date NA": {
        return !cellDateValue;
      }

      case "Overdue or due in 2 weeks": {
        const nextDate = DateUtils.dateTimeObj(todayDateValue)
          .add(15, "days")
          .valueOf();
        return cellDateValue < nextDate;
      }
      case "due after 2 weeks":
        {
          const nextDate = DateUtils.dateTimeObj(todayDateValue)
            .add(15, "days")
            .valueOf();
          return value && cellDateValue >= nextDate;
        }
        break;
      case "after date":
        {
          if (!model?.dateFrom) return false;
          const afterDate = DateUtils.dateTimeObj(model?.dateFrom).valueOf();
          return value && cellDateValue >= afterDate;
        }
        break;
      case "no date present":
        if (!cellDateValue) {
          return true;
        }
        return false;
        break;
      default:
        return false;
    }
  }

  return false;
};
